import { requestJson } from "./instateamEmployeeApi";

export function getEmployeeDocuments(token) {
  return requestJson("/instateam/documents/employee", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export function uploadRequestedDocument(token, requestId, file) {
  const formData = new FormData();
  formData.append("document", file);

  return requestJson(`/instateam/documents/employee/requests/${requestId}/upload`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: formData,
  });
}

export function deleteRequestedDocumentUpload(token, requestId) {
  return requestJson(`/instateam/documents/employee/requests/${requestId}/upload`, {
    method: "DELETE",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}
